import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {


  
  constructor(
    private translate: TranslateService,
    @Inject(DOCUMENT) private document: Document
  ) {
    const savedLang = localStorage.getItem('currentLang') || 'ar';
    this.changeLanguage(savedLang); // Apply initial language on service load
  }
    private lang = new BehaviorSubject<string>("en");
  currentLang = this.lang.asObservable();


/*----------  Getting Language from local storage  ----------*/
  getLanguage(): string {
    return localStorage.getItem('currentLang') || 'ar';
  }

  changeLanguage(lang: string): void {
    this.lang.next(lang);
    localStorage.setItem('currentLang', lang);
    this.translate.use(lang);
    this.setDirection(lang);
  }

  applyCurrentLanguage(): void {
    const lang = this.getLanguage();
    this.lang.next(lang);
    this.translate.use(lang);
    this.setDirection(lang);
  }

  private setDirection(lang: string): void {
    const dir = lang === 'ar' ? 'rtl' : 'ltr';
    const align = lang === 'ar' ? 'right' : 'left';
    this.document.body.dir = dir;
    this.document.body.style.textAlign = align;
  }
}